import { Button, CircularProgress, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get, includes, orderBy } from "lodash";
import { useState } from "react";
import { Link } from "react-router-dom";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import Snackbar from "../../../common/js/components/KMSnackbar";
import RestrictedAccess from "../../../common/js/components/RestrictedAccess.js";
import { Search, Sorty } from "../../../common/js/icons";
import schema from "../admin/userListingsTable";
import AdImportModal from "./AdImportModal";
import { user_search_options } from "./constants";
import UserHistoryModal from "./UserHistoryModal.js";

// Toolbar wrapper
const StyledPageToolbar = styled("div")({
    margin: "20px",
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
});

// Centered alternative content block
const StyledAlternateContent = styled("div")({
    margin: "auto",
    textAlign: "center",
    marginTop: "6em",
    marginBottom: "6em",
    color: "rgba(0, 0, 0, 0.30)",
    fontSize: "20px",
});

// Link button style
const StyledLb = styled(Link)({
    textDecoration: "none",
    color: "#2C99D2",
    fontWeight: 600,
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
    },
});

// Office history wrapper
const StyledOfficeHistory = styled(Button)({
    marginRight: "25px",
    marginLeft: "0px",
});

// Search bar containers
const StyledSearchBar = styled("div")({
    display: "flex",
    justifyContent: "flex-end",
});

const StyledSearchBarContainer = styled("div")({
    display: "flex",
    justifyContent: "space-between",
});

// Sortable column indicator
const StyledSortable = styled("span")({
    paddingRight: "5px",
    paddingBottom: "3px",
});

// Loading spinner centering
const StyledLoadingSpinner = styled("div")({
    position: "absolute",
    left: "50%",
    top: "60%",
    transform: "translate(-50%, -50%)",
    marginTop: "100px",
});

const UserListings = (props) => {
    const {
        columnToSort,
        filterQuery,
        handleChangeUserSearchType,
        handleGetUserOfficeHistory,
        handleFilter,
        handleSearchUsers,
        handleSort,
        isLoading,
        sortDirection,
        switchTab,
        userOfficeHistory,
        users,
        userProfile,
        userSearchType,
        userTab,
    } = props;

    const { ...unstyledProps } = props;

    const [searchRun, setSearchRun] = useState(false);
    const [historyModal, setHistoryModal] = useState(false);
    const [userAccountKeyForHistory, setUserAccountKeyForHistory] = useState(null);
    const [nameForHistory, setNameForHistory] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarVariant, setSnackbarVariant] = useState("");
    const [modalOpen, setModalOpen] = useState(false);

    const onKeyPress = (event) => {
        if (event.key === "Enter") {
            setSearchRun(true);
            handleSearchUsers();
        }
    };

    const handleShowModal = (view, name, userAccountKey) => {
        setHistoryModal(view);
        setUserAccountKeyForHistory(userAccountKey);
        setNameForHistory(name);
        if (view) {
            handleGetUserOfficeHistory(userAccountKey);
        }
    };

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleADImportResponse = (result) => {
        if (result === true) {
            setSnackbarMessage("Success: Import Process Started");
            setSnackbarVariant("success");
            setSnackbarOpen(true);
        } else {
            setSnackbarMessage("Failed: An Unknown Error Occurred");
            setSnackbarVariant("error");
            setSnackbarOpen(true);
        }
    };

    const sortedData = orderBy(
        filterQuery && users
            ? users.filter((x) => schema.filterByQuery(x, schema.columnsToQueryFilter, filterQuery))
            : users,
        columnToSort,
        sortDirection
    );

    if (includes(["dataAdmin"], get(userProfile, "role", null))) {
        return (
            <div>
                <Snackbar
                    open={snackbarOpen}
                    message={snackbarMessage}
                    variant={snackbarVariant}
                    vertical="top"
                    horizontal="center"
                    autoHideDuration={3000}
                    onClose={() => {
                        setSnackbarOpen(false);
                    }}
                />
                <StyledPageToolbar>
                    <div>
                        <h2 className="page-title">User Admin</h2>
                    </div>
                    <Button disabled={false} variant="contained" color="primary" onClick={() => handleOpenModal()}>
                        Run AD Import
                    </Button>
                    <AdImportModal
                        modalOpen={modalOpen}
                        closeModal={handleCloseModal}
                        adImportResponse={handleADImportResponse}
                    />
                </StyledPageToolbar>
                <div className="simPaper">
                    <StyledSearchBarContainer>
                        <div>
                            <Tabs value={userTab} onChange={switchTab}>
                                <Tab value="active_users" label="Active Users" />
                                <Tab value="inactive_users" label="Inactive Users" />
                            </Tabs>
                        </div>
                        <StyledSearchBar>
                            <BSInput
                                id="searchUsers"
                                value={filterQuery}
                                placeholder="Search Users"
                                errorPlaceholder="hideIt"
                                startAdornment={<Search />}
                                onChange={(event) => {
                                    handleFilter(event.target.value);
                                }}
                                onKeyPress={(e) => onKeyPress(e)}
                                extraFormControlStyles={{ marginTop: "0" }}
                            />
                            <div style={{ marginRight: "10px" }}>
                                <BSSelect
                                    extraInputStyles={{ marginTop: "0px", width: "150px" }}
                                    id="userSearchType"
                                    value={userSearchType}
                                    options={user_search_options}
                                    onChange={(e) => handleChangeUserSearchType(e.target.value)}
                                />
                            </div>
                        </StyledSearchBar>
                    </StyledSearchBarContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {schema.viewHeaders["default_headers"].map((x, i) => (
                                    <TableCell key={`thc-${i}`}>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                width: x.name === "Office History" ? "185px" : "",
                                            }}
                                            onClick={() => handleSort(x.sort ? x.sort : x.prop)}
                                        >
                                            <StyledSortable>{x.name}</StyledSortable>

                                            {x.name && (
                                                <div>
                                                    <Sorty />
                                                </div>
                                            )}
                                        </div>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading && searchRun && !historyModal ? (
                                <StyledLoadingSpinner>
                                    <CircularProgress color="primary" />
                                </StyledLoadingSpinner>
                            ) : (
                                sortedData.map((user, i) => row(user, i, isLoading, handleShowModal))
                            )}
                        </TableBody>
                    </Table>
                    {!searchRun && (
                        <div>
                            <StyledAlternateContent>Please apply search criteria</StyledAlternateContent>
                        </div>
                    )}
                </div>
                <UserHistoryModal
                    {...unstyledProps}
                    handleShowModal={handleShowModal}
                    showModal={historyModal}
                    userOfficeHistoryData={get(userOfficeHistory, userAccountKeyForHistory, null)}
                    userAccountKey={userAccountKeyForHistory}
                    name={nameForHistory}
                />
            </div>
        );
    } else {
        return <RestrictedAccess />;
    }
};
const row = (x, i, isLoading, handleShowModal) => {
    return (
        !isLoading && (
            <TableRow key={`tr-${i}`} selectable="false">
                {schema.viewHeaders["default_headers"].map((y, k) => (
                    <TableCell key={`trc-${k}`} style={{ width: y.name === "Office History" ? "185px" : "" }}>
                        {y.name === "NAME" ? (
                            <StyledLb to={`/admin/user/${x.userAccountKey}`} data-testid={`AdminUserLink-${i}`}>
                                {get(x, "name", "")}
                            </StyledLb>
                        ) : y.transform ? (
                            y.transform(x)
                        ) : (
                            get(x, y.prop, "")
                        )}
                        {y.name === "Office History" ? (
                            <StyledOfficeHistory
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                    handleShowModal(
                                        true,
                                        `${get(x, "firstName", null)} ${get(x, "lastName", null)}`,
                                        get(x, "userAccountKey", null)
                                    )
                                }
                            >
                                View History
                            </StyledOfficeHistory>
                        ) : (
                            ""
                        )}
                    </TableCell>
                ))}
            </TableRow>
        )
    );
};

export default UserListings;
